<template>
  <div class="container">
    <h1>Study selection</h1>
    <p>
      To ensure a better matching between student and company we would like to know what studies you are interested in.
      We would also like to know if you are interested in PhD and PDEng candidates.
      What studies is your company interested in?
    </p>
    <table class="table table-sm table-bordered">
      <thead>
        <tr class="thead-light">
          <th colspan="3">Studies</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="study in studies" v-bind:key="study.id">
          <td>
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                v-model="subscriberData[study.id]"
                :id="study.id"
              />
              <label class="custom-control-label" :for="study.id"></label>
            </div>
          </td>
          <td>
            <label :for="study.id">{{study.name}}</label>
          </td>
          <td>
            <button
              class="btn btn-sm btn-secondary"
              @click="showStudy(study);"
              :data-id="study.id"
            >More info</button>
          </td>
        </tr>
      </tbody>
    </table>
    <Modal v-if="showModal" v-on:close="showModal = false">
      <slot slot="header">
        <h3>{{visibleStudy.name}}</h3>
      </slot>
      <slot slot="body"><div class="text-justify" v-html="visibleStudy.description"></div></slot>
    </Modal>
    <router-link to="/subscribe/contact-information">
      <button class="btn btn-secondary">Back</button>
    </router-link>
    <router-link to="/subscribe/package-selection">
      <button class="btn btn-primary">Next</button>
    </router-link>
  </div>
</template>

<script>
import Modal from "@/components/Modal.vue";

export default {
  name: "StudySelection",
  components: {
    Modal
  },
  data() {
    return {
      showModal: false,
      visibleStudy: {}
    };
  },
  computed: {
    subscriberData() {
      return this.$store.state.subscriberData;
    },
    studies() {
      return this.$store.getters.studies;
    }
  },
  methods: {
    showStudy(study) {
      this.visibleStudy = study;
      this.showModal = true;
    }
  }
};
</script>

<style scoped lang="scss">
</style>
